require('expose-loader?SportsbookBetBoost!../../../src/app/sportsbook/home_components/bet_boost');
